import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownEditor = ({ name, value, onChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Editor */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Description (Markdown)
        </label>
        <textarea
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          rows={14}
          placeholder="Write project scope using Markdown..."
          className="w-full border rounded p-3 text-sm font-mono focus:ring focus:ring-blue-200"
        />
      </div>

      {/* Preview */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Live Preview
        </label>
        <div className="border rounded p-3 bg-gray-50 prose prose-sm max-w-none">
          {value ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {value}
            </ReactMarkdown>
          ) : (
            <p className="text-gray-400">Nothing to preview yet…</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarkdownEditor;
